import { TableCell, TableRow } from "@mui/material";
import type { ReactNode } from "react";
import {
  getGroupBackground,
  getGroupFrameBorder,
  getGroupHeaderDivider,
} from "@/pages/sy/utils/layerGroupFrame";

interface LayerGroupHeaderRowProps {
  layerNumber: number;
  labelColSpan: number;
  values: ReactNode[];
}

export const LayerGroupHeaderRow = ({
  layerNumber,
  labelColSpan,
  values,
}: LayerGroupHeaderRowProps) => (
  <TableRow
    sx={(theme) => ({
      height: "32px",
      backgroundColor: getGroupBackground(theme),
      cursor: "default",
      "& td": {
        padding: theme.spacing(0.5, 2),
        fontSize: "1rem",
        fontWeight: "bold",
        borderTop: getGroupFrameBorder(theme),
        borderBottom: getGroupHeaderDivider(theme),
      },
      "& td:first-of-type": { borderLeft: getGroupFrameBorder(theme) },
      "& td:last-of-type": { borderRight: getGroupFrameBorder(theme) },
    })}
  >
    <TableCell colSpan={labelColSpan}>Layer {layerNumber}</TableCell>
    {values.map((value, index) => (
      <TableCell key={index} align="center">
        {value}
      </TableCell>
    ))}
  </TableRow>
);
